import React from 'react';
import VContentContainer from '../../components/VContentContainer/VContentContainer';
import VDatePicker from '../../components/VDatePicker/VDatePicker';
import VDropdown from '../../components/VDropdown/VDropdown';
import VFilterContainer from '../../components/VFilterContainer/VFilterContainer';
import VMainContainer from '../../components/VMainContainer/VMainContainer';
import { SpinnerManager } from '../../components/VSpinner/SpinnerManager';
import { alertError, alertSuccess, handleApiError, specifyErrorMessage } from '../../helpers/errorHelper';
import { extractDate } from '../../helpers/generalHelper';
import { getLocalStorage, setLocalStorage } from '../../helpers/localStorageHelper';
import { portalMessages } from '../../helpers/portalMessages';
import history from '../../history';
import {
    getTcatSchedule,
    sendTcatSchedule
} from '../../apis/vitusApi';
import VTable from '../../components/VTable/VTable';
import { isEmpty } from 'lodash';

class TcatSchedule extends React.Component {
    spinner = new SpinnerManager(history.location.pathname);
    storedActiveFilter = getLocalStorage('tcatSchedule', 'filters', 'activeFilter') || {};

    vitus = 'Vitus'

    periods = {
        LT: { label: 'LT', name: 'Long Term' },
        ST: { label: 'ST', name: 'Short Term' }
    }

    state = {
        activeFilterToDisplay: [],
        selectedDate: this.getDefaultDate(),
        counterPartyOptions: [],
        periodOptions: [],
        activeFilter: {
            scheduleDate: null,
            period: this.storedActiveFilter?.period,
        },
        scheduleList: [],
        scheduleVersion: 1,
    };

    errorMessages = {
        Default: portalMessages.UNEXPECTED_ERROR_OCCURED + ' (Default)'
    };

    // ['Capacity ID', 'Counterparty', 'Hour']
    columnNames = {
        capacityID: 'Capacity ID',
        counterParty: 'Counterparty',
        hour: 'Hour'
    }

    columnMatcher = {
        "capacityAgreement": "Capacity ID",
        "inParty": "Counterparty",
        "outParty": "Counterparty"
    }

    counterparties = {
        '40X000000009445K': 'Vitus',
        '32X001100101073T': 'Energovia',
        '12X-0000001905-X': 'Ensco'
    }

    getPeriodOptions() {
        return Object.keys(this.periods).map(c => { return { value: this.periods[c].label, label: this.periods[c].name } })
    }

    getCompanyOptions() {
        return Object.keys(this.companies).map(c => { return { value: this.companies[c].name, label: this.companies[c].label } })
    }

    componentDidMount() {
        let selectedPeriodOption;

        const periodOptions = this.getPeriodOptions();

        if (this.state.activeFilter.period) {
            selectedPeriodOption = periodOptions.filter(e => e.label === this.state.activeFilter.period);

            if (selectedPeriodOption.length !== 0)
                selectedPeriodOption = selectedPeriodOption[0];
            else
                selectedPeriodOption = "";
        }

        if (!selectedPeriodOption) {
            selectedPeriodOption = periodOptions[0];
        }

        this.setState({ periodOptions, selectedPeriodOption });

        const filter = {
            schedule_date: extractDate(this.state.selectedDate),
            period: selectedPeriodOption.value,
        };

        this.refreshTcatScheduleAsync(filter);
    }

    showErrorMessage(error, operationName) {
        const { message, errorType } = specifyErrorMessage(error, this.errorMessages, operationName);

        if (message)
            alertError(message);
    }

    refreshTcatScheduleAsync = async (filter) => {
        if (!filter)
            filter = {
                schedule_date: this.state.activeFilter.scheduleDate,
                period: this.state.activeFilter.period
            };

        return await this.getTcatScheduleAsync(filter)
    }

    getTcatScheduleAsync = async (filter) => {
        const spinnerKey = this.spinner.showSpinner();

        try {
            let response;

            try {
                response = await getTcatSchedule(filter);
            } catch (error) {
                handleApiError(error);
                return false;
            }

            if (response.data.success) {

                if (response.data.success.schedule_list.length === 0) {
                    alertSuccess(portalMessages.TCAT_SCHEDULE.NO_SCHEDULE.replace('[DATE]', filter.schedule_date));
                }
                this.setState({
                    scheduleList: response.data.success.schedule_list,
                    scheduleVersion: response.data.success.version,
                    activeFilter: {
                        scheduleDate: filter.schedule_date,
                        period: filter.period
                    },
                    activeFilterToDisplay: [
                        { label: "Schedule Date", value: filter.schedule_date },
                        { label: "Period", value: filter.period },
                    ]
                }, () => {
                    setLocalStorage('tcatSchedule', 'filters', 'activeFilter',
                        { scheduleDate: filter.schedule_date, period: filter.period });
                });

            } else if (!response.data.error) {
                this.showErrorMessage(portalMessages.UNEXPECTED_ERROR_OCCURED + ' (Tcat Schedule)');
            }

            if (response.data.error) {
                this.showErrorMessage(response.data.error);
            }

        } catch (error) {
            this.showErrorMessage(portalMessages.UNEXPECTED_ERROR_OCCURED + ' (Tcat Schedule)');
        } finally {
            this.spinner.hideSpinner(spinnerKey);
        }
    }

    sendTcatScheduleAsync = async () => {
        const spinnerKey = this.spinner.showSpinner();
        let response;

        let body = {
            'period': this.state.selectedPeriodOption.value,
            'schedule_date': extractDate(this.state.selectedDate)
        }

        try {
            response = await sendTcatSchedule(body);

            if (response.data.success) {
                alertSuccess(portalMessages.TCAT_SCHEDULE.SEND_SCHEDULE_SUCCESSFUL);
            }
            else {
                alertError(portalMessages.TCAT_SCHEDULE.SEND_SCHEDULE_ERROR);
            }
            return;
        } catch (error) {
            handleApiError(error);
            return false;
        }
        finally {
            this.onShowButtonClick();
            this.spinner.hideSpinner(spinnerKey);
        }
    }

    getMaxEditableDate() {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        return today.setDate(today.getDate() + 2);
    }

    getDefaultDate() {
        let today = new Date();
        today.setHours(0, 0, 0, 0);
        return today.setDate(today.getDate() + 1);
    }

    onShowButtonClick() {
        if (!this.state.selectedDate) {
            this.showErrorMessage(portalMessages.DATE_SELECTION);
            return;
        }

        if (!this.state.selectedPeriodOption || isEmpty(this.state.selectedPeriodOption)) {
            this.showErrorMessage(portalMessages.SELECT_PERIOD);
            return;
        }

        const filter = {
            schedule_date: extractDate(this.state.selectedDate),
            period: this.state.selectedPeriodOption.value,
        };

        this.refreshTcatScheduleAsync(filter);
    }

    renderScheduleTab() {
        if (this.state.scheduleList.length === 0) {
            return;
        }

        const headers = [[this.columnNames.capacityID], [this.columnNames.counterParty], [this.columnNames.hour]];
        const values = [];

        this.state.scheduleList[0].period.interval.forEach(hour_data => {
            values.push([hour_data.pos + 1]);
        })

        this.state.scheduleList.forEach(schedule => {
            const capacityID = schedule.capacityAgreement;
            const counterparty = this.counterparties[schedule.inParty] === this.vitus ? this.counterparties[schedule.outParty] : this.counterparties[schedule.inParty];
            headers[0].push(capacityID);
            headers[1].push(counterparty);
            headers[2].push('');

            schedule.period.interval.forEach((periodData, index) => {
                values[index].push(periodData.qty);
            })
        })

        return (
            <VTable
                key={`Schedule Data (Version: ${this.state.scheduleVersion})`}
                title={`Schedule Data (Version: ${this.state.scheduleVersion})`}
                items={{ headers, values }}
                readonlyColumns={[...Object.values(this.columnNames)]}
                customColumnClasses={{ 0: "v-column-narrow-bold" }}
                exportFileName={`TCAT_Schedule_${this.state.activeFilter.scheduleDate}_${this.state.activeFilter.period}`}
                headerButtons={{
                    showExportExcelButton: true
                }}
                showTotal
            />
        );

    }

    render() {
        return (
            <React.Fragment>
                <VContentContainer title="Tcat Schedule">
                    <VFilterContainer
                        showActiveFilter
                        activeFilter={this.state.activeFilterToDisplay}
                    >
                        <div className="v-filter-group">
                            <div className="v-filter-label v-label">
                                Date
                            </div>
                            <div>
                                <VDatePicker
                                    selectedDate={this.state.selectedDate}
                                    onSelectedDateChange={(selectedDate) => this.setState({ selectedDate })}
                                    maxDate={this.getMaxEditableDate()}
                                />
                            </div>
                        </div>
                        <div className="v-filter-group">
                            <div className="v-filter-label v-label">
                                Period
                            </div>
                            <div>
                                <VDropdown
                                    width="large"
                                    options={this.state.periodOptions}
                                    value={this.state.selectedPeriodOption}
                                    onSelectedOptionChange={(selectedPeriodOption) => {
                                        this.setState({
                                            selectedPeriod: selectedPeriodOption.value,
                                            selectedPeriodOption: selectedPeriodOption
                                        })
                                    }}
                                />
                            </div>
                        </div>
                        <div className="v-filter-buttons">
                            <button
                                tabIndex={0}
                                className="btn v-button v-filter-button"
                                onClick={() => this.onShowButtonClick()}>
                                <i aria-hidden="true" className="fa fa-search fa-fw" />Show
                            </button>
                        </div>
                    </VFilterContainer>
                    <VMainContainer>
                        <div className='col-12' style={{ textAlign: 'right', margin: '5px 0 0 0', padding: '0' }}>
                            <button className="btn v-button v-tab-button"
                                onClick={() => this.sendTcatScheduleAsync()}>
                                <i aria-hidden="true" />
                                Send TCAT Schedule
                            </button>
                        </div>
                        {this.renderScheduleTab()}
                    </VMainContainer>
                </VContentContainer>
            </React.Fragment>
        );
    }
}

export default TcatSchedule;